import { SplashScreen } from '@cigam/template/dist/components';
import { useSnackbar } from 'notistack';
import qs from 'qs';
import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'src/store';
import { runtimeConfigs } from 'src/config/runtimeConfigs';
import {
  handleAuthentication,
  isAuthenticated,
  loginInWithToken,
  setAxiosInterceptors,
  logout as logoutService,
  getAccessToken,
  setAccessToken,
} from 'src/Areas/Genericos/GE/services/authService';
import axios from 'src/utils/axios';
import { logout, setAccount } from 'src/Areas/Genericos/GE/slices/account';
import { loadAllDireitos } from 'src/Areas/Genericos/GE/services/direitosService';
import {
  buscarAplicacoesWeb,
  verificarConectividade,
  buscarDadosSobre,
} from 'src/Areas/Genericos/GE/services/ambienteService';
import { useSettings } from '@cigam/template/dist/hooks/useSettings';
import { setHistoryNavigation } from 'src/Areas/Genericos/GE/slices/historyNavigation';
import { verificarAutenticacaoA2F } from 'src/Areas/Genericos/GE/services/pessoaService';

interface Props {
  children: ReactNode;
}

export function Auth({ children }: Props) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { hash } = qs.parse(useLocation().search, { ignoreQueryPrefix: true });
  const { settings } = useSettings();
  const path = window.location.pathname.split('/');
  const portal = path[1].includes('portal')
    ? `${path[1]}`
    : settings.defaultPortal || settings.activePortals[0];

  useEffect(() => {
    const initAuth = async () => {
      let hashUrl = hash;
      if (hashUrl && hashUrl !== getAccessToken()) {
        setAxiosInterceptors(() => dispatch(logout()));
        setAccessToken(null);
      } else {
        hashUrl = getAccessToken() || '';
      }

      const enviroment = await runtimeConfigs();

      if (enviroment) {
        axios.defaults.baseURL = `${enviroment.API_URL}/api`;
      }

      await handleAuthentication(String(hashUrl), portal);

      if (isAuthenticated()) {
        try {
          const user = await loginInWithToken(portal);
          const tipoLogin = settings.defaultLogin;
          const direitos = await loadAllDireitos();
          const hashPortais = getAccessToken();
          const dadosPortais = await buscarAplicacoesWeb(
            `${enviroment.API_URL}`.includes('https')
          );
          const dadosSobre = await buscarDadosSobre();
          let possuiConectividade: boolean;
          possuiConectividade = false;
          const dadosCia = dadosPortais.data.Aplicacoes.filter(x =>
            x.Endereco.includes('cia')
          )[0];
          if (dadosCia !== null) {
            const endereco = dadosCia.Endereco.concat('?cigam=')
              .concat(enviroment.API_URL)
              .concat(hashPortais ? '&hash='.concat(hashPortais) : '');

            const verificaConectividade = await verificarConectividade(
              endereco,
              true
            );
            possuiConectividade = verificaConectividade.data.IsAvailable;
          }

          const verificaA2F = await verificarAutenticacaoA2F(user.Codigo);
          const possuiA2F = verificaA2F.data.PossuiAutenticacaoA2F;
          dispatch(
            setAccount({
              user,
              tipoLogin,
              direitos,
              dadosPortais,
              possuiConectividade,
              possuiA2F,
              dadosSobre,
            })
          );
        } catch (error) {
          enqueueSnackbar(String(error), { variant: 'error' });
          logoutService();
        }
      } else if (path && path[1]) {
        dispatch(setHistoryNavigation(window.location.pathname));
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch, enqueueSnackbar, hash]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
